// components/games/GameIcons.js — SVG icon set for mini-games (no external deps)

const BASE = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function Icon({ size = 20, color, style, className, children, filled }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      style={{ flexShrink: 0, color, ...style }}
      className={className}
      aria-hidden="true"
      {...(filled ? { fill: 'currentColor', stroke: 'none' } : BASE)}
    >
      {children}
    </svg>
  );
}

export function ArrowLeftIcon(p) {
  return <Icon {...p}><path d="M19 12H5M12 5l-7 7 7 7"/></Icon>;
}
export function ChevronRightIcon(p) {
  return <Icon {...p}><polyline points="9 18 15 12 9 6"/></Icon>;
}
export function UndoIcon(p) {
  return <Icon {...p}><path d="M3 7v6h6"/><path d="M21 11a9 9 0 00-9-8 9.75 9.75 0 00-6.74 2.74L3 8"/></Icon>;
}
export function EraserIcon(p) {
  return <Icon {...p}><path d="M21 4H8L1 12l7 8h13a2 2 0 002-2V6a2 2 0 00-2-2z"/><line x1="18" y1="9" x2="12" y2="15"/><line x1="12" y1="9" x2="18" y2="15"/></Icon>;
}
export function PencilIcon(p) {
  return <Icon {...p}><path d="M17 3a2.828 2.828 0 014 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></Icon>;
}
export function LightbulbIcon(p) {
  return <Icon {...p}><path d="M9 18h6M10.5 21h3"/><path d="M12 3a6 6 0 016 6c0 2.5-1.5 4.5-3.5 5.5L14 17H10l-.5-2.5A6.5 6.5 0 016 9a6 6 0 016-6z"/></Icon>;
}
export function PauseIcon(p) {
  return <Icon {...p}><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></Icon>;
}
export function PlayIcon(p) {
  return <Icon {...p}><polygon points="5 3 19 12 5 21 5 3"/></Icon>;
}
export function AlertTriangleIcon(p) {
  return <Icon {...p}><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></Icon>;
}
export function CalendarIcon(p) {
  return <Icon {...p}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></Icon>;
}
export function ShuffleIcon(p) {
  return <Icon {...p}><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/><line x1="4" y1="4" x2="9" y2="9"/></Icon>;
}
export function TrophyIcon({ size = 24, color = 'currentColor', style, className }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ flexShrink: 0, ...style }} className={className} aria-hidden="true">
      <line x1="8" y1="21" x2="16" y2="21"/>
      <line x1="12" y1="17" x2="12" y2="21"/>
      <path d="M7 4h10v8a5 5 0 01-10 0V4z"/>
      <path d="M17 9h2.5a2.5 2.5 0 000-5H17"/>
      <path d="M7 9H4.5a2.5 2.5 0 010-5H7"/>
    </svg>
  );
}
export function SudokuIcon(p) {
  return <Icon {...p}><rect x="3" y="3" width="6" height="6" rx="1"/><rect x="9" y="3" width="6" height="6" rx="1"/><rect x="15" y="3" width="6" height="6" rx="1"/><rect x="3" y="9" width="6" height="6" rx="1"/><rect x="9" y="9" width="6" height="6" rx="1"/><rect x="15" y="9" width="6" height="6" rx="1"/><rect x="3" y="15" width="6" height="6" rx="1"/><rect x="9" y="15" width="6" height="6" rx="1"/><rect x="15" y="15" width="6" height="6" rx="1"/></Icon>;
}
export function MystereIcon(p) {
  return <Icon {...p}><path d="M4 20l4-12 4 12"/><path d="M6 15h4"/><line x1="14" y1="20" x2="14" y2="8"/><line x1="20" y1="20" x2="20" y2="8"/><line x1="14" y1="14" x2="20" y2="14"/></Icon>;
}
export function BrinIcon(p) {
  return <Icon {...p}><circle cx="12" cy="5" r="2" fill="currentColor" stroke="none"/><circle cx="5" cy="19" r="2" fill="currentColor" stroke="none"/><circle cx="19" cy="19" r="2" fill="currentColor" stroke="none"/><line x1="12" y1="7" x2="5" y2="17"/><line x1="12" y1="7" x2="19" y2="17"/><line x1="7" y1="19" x2="17" y2="19"/></Icon>;
}
